import { Tabs } from "antd"
import ProposalTable from "features/clients/components/proposalsTab/proposalTable"
import LeadReviewTable from "features/leads/components/LeadReviewTable/leadReviewTable"
import ConversionProbability from "../conversionProbability/conversionProbability"
import { TasksTable } from "features/tasks/components"
import { t } from "i18next"
import { useState } from "react"
import { useSelector } from "react-redux"
import getPrivilege from "utils/privileges/privileges"

const TaskReviewsTabs = ({ client, lead, clientLeads, taskTableProps, tabKey }) => {
  const [activeKey, setActiveKey] = useState(tabKey || "tasks")
  const userPrivileges = useSelector(state => state.app.privileges)
  const items = [
    {
      key: "tasks",
      label: t("Tasks"),
      children: (
        <TasksTable stickyOffset={-16} client={client} clientLeads={clientLeads} lead={lead} {...taskTableProps} />
      ),
    },
    {
      key: "proposals",
      label: t("Proposals"),
      children: <ProposalTable client={client} lead={lead} />,
      show: getPrivilege("can_see_task_logs", userPrivileges),
    },
    {
      key: "leadReview",
      label: t("Reviews"),
      children: <LeadReviewTable client={client} lead={lead} />,
    },
    {
      key: "conversionProbability",
      label: t("Conversion Progression"),
      children: <ConversionProbability client={client} leadId={lead?.id} />,
    },
  ]
  return (
    <Tabs
      activeKey={activeKey}
      items={items}
      onChange={key => {
        setActiveKey(key)
      }}
    />
  )
}
export default TaskReviewsTabs
